module.exports = __webpack_public_path__ + "img/iBowKINTAI-Horizontal-white.f00de823.svg";